module.exports = __webpack_public_path__ + "static/media/confirm-email.0573ede0.png";